
// $('.game-mobile-search').click(function(){
//  $(".mobile-search-header").toggle();
// });

$('.mobile-dropdown.mobile-dropdown__position--left').click(function(){
 $('.mobile-menu__toggle-icon').toggleClass('is-active');
});